import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var PriorityIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M18.059 3.002c.236.014.468.11.648.29l4 4a1 1 0 11-1.414 1.415L19 6.415V20a1 1 0 01-1.993.117L17 20V6.414l-2.293 2.293a1 1 0 01-1.32.083l-.094-.083a1 1 0 01-.083-1.32l.083-.094 4-4a.996.996 0 01.648-.291zM14 17a1 1 0 01.117 1.993L14 19H2a1 1 0 01-.117-1.993L2 17h12zm0-5a1 1 0 01.117 1.993L14 14H2a1 1 0 01-.117-1.993L2 12h12zm-4-5a1 1 0 01.117 1.993L10 9H2a1 1 0 01-.117-1.993L2 7h8z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
PriorityIcon.isCarinaIcon = true;
export default PriorityIcon;
